const device = {
  // xs is the default
  sm: '(min-width: 576px)', // landscape phones
  md: '(min-width: 768px)', // tablets
  lg: '(min-width: 992px)', // Desktops
  xl: '(min-width: 1200px)' // Monitors, PCs etc.
};

export default device;
